//list of constants that do not change. 

//in beat saber, each note is worth 115 points, with combo multiplier of (max) 8 
export const maxScorePerNote = 115;
export const comboMultiplier = 8;

//number of scores per page of data in scoresaber api
export const scoresPerPage=8;
export const scoresPerLeaderboardPage=12;//scores per page on leaderboard

//beat saver urls
export const beatsaverMapPrefix = "https://beatsaver.com/maps/";
export const iconURL = "https://beatsaver.com/static/icons/";
export const mapCoverURL = "https://na.cdn.beatsaver.com/"//<append hash>
// score saber urls
export const ssLeaderboardURL = 'https://scoresaber.com/leaderboard/';
export const ssWebProfilePrefix = 'https://scoresaber.com/u/';
export const blWebProfilePrefix = 'https://beatleader.xyz/u/';